module.exports = __webpack_public_path__ + "c1bf79e860bae9dc9ba8e08d2251acf1.svg";